import Header from '../Global/Header';
import Breadcrumb from '../Global/Breadcrumb';
import Contactus from '../Maincontactus/Contactus';
import Callto from '../Global/Callto';
import Footer from '../Global/Footer';
import Gototop from '../Global/Gototop';

const Main = () => {
  return (
    <>
      <Header />
      <Breadcrumb Title="Contact Us" Subtitle="Contact Us" />
      <div className='page_wrapper'>
        <Contactus />
        <Callto />
        <Footer />
        <Gototop/>
      </div>
    </>
  )
}

export default Main
